import React from "react";
import { Settings2 } from "lucide-react";
import { Tooltip } from "@mui/material";
import { Input } from "components/Graphs/Input";
import { Textarea } from "components/Graphs/TextArea";
import { SectionShell } from "../layout";
import type { SectionControlProps } from "../types";

export const DetailsSection: React.FC<
  SectionControlProps & {
    name: string;
    description: string;
    isEditMode: boolean;
    loadingCreatingLaunchable: boolean;
    onNameChange: (name: string) => void;
    onDescriptionChange: (description: string) => void;
  }
> = ({
  name,
  description,
  isEditMode,
  loadingCreatingLaunchable,
  onNameChange,
  onDescriptionChange,
  ...sectionProps
}) => (
  <SectionShell
    id="details"
    title="Details"
    detailItems={[
      ...(name.trim() ? [{ label: "Name", value: name.trim() }] : []),
      ...(description.trim()
        ? [{ label: "Description", value: description.trim() }]
        : []),
    ]}
    icon={<Settings2 className="h-5 w-5" />}
    {...sectionProps}
  >
    <div className="space-y-4">
      <div>
        <label
          htmlFor="launchable-name"
          className="text-sm font-medium text-primary"
        >
          Name
          <span className="ml-1 text-red-400" aria-hidden="true">
            *
          </span>
          <span className="sr-only"> (required)</span>
        </label>
        <Tooltip
          title={isEditMode ? "Launchable names are not editable." : ""}
          placement="top"
        >
          <span className="block">
            <Input
              id="launchable-name"
              required
              autoFocus={!isEditMode}
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              placeholder="Enter a name"
              disabled={loadingCreatingLaunchable || isEditMode}
              className="mt-1.5"
            />
          </span>
        </Tooltip>
      </div>
      <div>
        <label
          htmlFor="launchable-description"
          className="text-sm font-medium text-primary"
        >
          Description{" "}
          <span className="font-normal text-secondary">(optional)</span>
        </label>
        <Textarea
          id="launchable-description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Add a short description"
          disabled={loadingCreatingLaunchable}
          className="mt-1.5"
          rows={4}
        />
      </div>
    </div>
  </SectionShell>
);
